<script setup>

</script>

<template>
    <div class="max-w-7xl mx-auto px-4">
        <h1 class="text-2xl font-semibold text-gray-900">Dashboard</h1>
    </div>
    <div class="max-w-7xl mx-auto px-4">
        <div class="py-4">
            <div class="border-4 border-dashed border-gray-200 rounded-lg h-96"></div>
        </div>
    </div>
</template>

<script>
import BackofficeLayout from '@/Layouts/BackofficeLayout'
export default {
    layout: BackofficeLayout,
}
</script>
